import { render, staticRenderFns } from "./list_comment_total_cell.vue?vue&type=template&id=765b6dfd&scoped=true&"
import script from "./list_comment_total_cell.vue?vue&type=script&lang=js&"
export * from "./list_comment_total_cell.vue?vue&type=script&lang=js&"
import style0 from "./list_comment_total_cell.vue?vue&type=style&index=0&id=765b6dfd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765b6dfd",
  null
  
)

export default component.exports